import { useCallback, useSyncExternalStore } from 'react';

/**
 * Seconds remaining until `untilMs` (epoch ms); 0 when passed or unset. Implemented as an
 * external "clock" store so reading the time happens in the snapshot, not during render.
 */
export function useCountdown(untilMs: number | null): number {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!untilMs) return () => undefined;
      const id = setInterval(onChange, 250);
      return () => clearInterval(id);
    },
    [untilMs],
  );
  const getSnapshot = useCallback(
    () => (untilMs ? Math.max(0, Math.ceil((untilMs - Date.now()) / 1000)) : 0),
    [untilMs],
  );
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

/** "m:ss" for long waits, plain seconds for short ones. */
export function formatSeconds(total: number): string {
  if (total >= 60) {
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  }
  return String(total);
}
